import { AddressModel } from '../../address.model';
import { SocialNetworksModel } from './social-networks.model';
import { CommunicationModel } from '../../communication.model';
import { CreditCardPaymentInfoModel } from './credit-card-payment-info-model';
import {  NotificationSettingsModel } from './notification-settings-model';
import { UserBaseModel } from 'src/app/core/models/members/user/user-base.model';

export const enum AccountStatus {
  Pending = 0, //requires Admin approval
  Onboarding = 1, 
  Approved = 2,
  Disabled = 3,
  PasswordReset = 4,
}

export class UserModel extends UserBaseModel {
  password: string = "";
  title: string ="";
  bio?: string;
  pic?: string;  
  occupation?: string;
  companyName?: string;
  phoneNumber?: string;
  address: AddressModel = new AddressModel();
  socialNetworks: SocialNetworksModel = new SocialNetworksModel();
  website?: string;
  // account information
  language?: string;
  timeZone?: string;
  accountStatus?: AccountStatus;
  //payment
  paymentInfo: CreditCardPaymentInfoModel = new CreditCardPaymentInfoModel;
  paymentMethods?: string;
  //signature
  signaturePointsString?: string;
  //signature: byte[] = [];
  signature?: string;
  initials?: string;
  communication: CommunicationModel = new CommunicationModel();
  // email settings
  notificationSettings: NotificationSettingsModel = new NotificationSettingsModel();
  isMultiFactorAuthenticationEnabled: boolean = false;
  
  setUser(_user: unknown) {
    const user = _user as UserModel;
    this.id = user.id;
    this.userName = this.email = user.email || "";
    this.password = user.password || "";
    this.name = user.name || "";
    this.lastName = user.lastName || "";
    this.pic = user.pic || './assets/media/avatars/blank.png';   
    this.occupation = user.occupation || "";
    this.companyName = user.companyName || "";
    this.phoneNumber = user.phoneNumber || "";
    this.address = user.address;
    this.socialNetworks = user.socialNetworks;
    this.accountStatus = AccountStatus.Approved;
    this.enabled = true;
    this.isEmailVerified = false;
  }
}